module.exports = __webpack_public_path__ + "img/armor-making.b252cfbe.png";